import React, { useRef, useEffect } from 'react';
import { gsap } from '../../../gsap';
import './CopyBlocks.scss';

function HighlightedCopy({ copyData }) {
  const container = useRef();

  useEffect(() => {
    const refs = [];
    copyData.forEach((data) => {
      refs.push(data.ref);
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container.current,
        start: 'top 60%'
      }
    });
    refs.forEach((ref, i) => {
      i < refs.length - 1
        ? tl
            .to(
              ref.current,
              {
                color: '#FFFFFF',
                duration: 0.7
              },
              '<'
            )
            .to(ref.current, {
              color: '#767676',
              duration: 0.5
            })
        : tl.to(ref.current, {
            color: '#FFFFFF',
            duration: 0.7
          });
    });
  }, [copyData]);

  return (
    <p className="highlightedCopy" ref={container}>
      {copyData.map((copy, i) => {
        return (
          <span ref={copy.ref} key={i}>
            {copy.copy}
          </span>
        );
      })}
    </p>
  );
}

export default HighlightedCopy;
